import React, { useEffect, useState } from "react";
import { EditBlockOption } from "../EditBlock";
import { OptionIsRight, TopicType } from "../../../../../service/homework";
import { EditZhuguanPure } from "../../../../exam/addExam/components/EditZhuguan";
import { EditBlock } from "../EditBlock";
import { QuestionType } from "../../../../../service/service";
import { Col, Row } from "antd";
import Editor from "../../../../../components/Editor";
import style from "../../../../exam/addExam/components/EditZhuguan/EditZhuguan.module.scss";

interface EditZhuguanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditZhuguan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditZhuguanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);
    const referenceText =
        innerTopic.answers &&
        innerTopic.answers[0] &&
        innerTopic.answers[0].content
            ? innerTopic.answers[0].content
            : "";

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    function onReferenceChange(text: string) {
        setInnerTopic({
            ...innerTopic,
            answers: [{ content: text, isRight: OptionIsRight.Right }]
        });
    }

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.ZhuGuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditZhuguanPure
                innerTopic={innerTopic}
                setInnerTopic={setInnerTopic}
            />

            <Row style={{ marginTop: 20 }}>
                <Col span={3} className={style.label}>
                    参考答案：
                    <p className={style.tip}>
                        (参考答案在判分之前不会显示给学员)
                    </p>
                </Col>

                <Col span={20}>
                    <Editor data={referenceText} onChange={onReferenceChange} />
                </Col>
            </Row>
        </EditBlock>
    );
}
